import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/*
 * Pre-rendered pages arrive with their full HTML (for search engines and a
 * fast first paint). They are snapshots of the finished page, not React
 * server output, so hydrating them always failed (React error 418) and React
 * re-rendered anyway. Rendering fresh over the snapshot gives the same result
 * without the failed attempt.
 */
const root = document.getElementById("root");

/*
 * A snapshot also carries its page's head tags. The page renders the same tags
 * again when it mounts (react-helmet-async 3 hands them to React 19, which adds
 * them and never replaces the snapshot's), so a crawler that runs JavaScript
 * saw two titles, two canonicals, two descriptions and every Open Graph,
 * hreflang and JSON-LD tag twice (Bing: "More than one canonical tag"). The
 * snapshot's copies go first. Only on pre-rendered pages: the plain shell
 * (_spa.html) keeps index.html's defaults for pages that set none.
 */
if (root.firstElementChild) {
  // A chunk tag saved in a snapshot points at another build's file. Webpack reuses a tag
  // with the same data-webpack name and waits on it forever (24 Oct: "Get visa help" on
  // the homepage did nothing), so none may survive into the running app.
  document.querySelectorAll("script[data-webpack], link[data-webpack]").forEach((el) => el.remove());
  document.head
    .querySelectorAll(
      'title, meta[name="description"], meta[name="robots"], meta[name^="twitter:"], meta[property^="og:"], meta[property^="article:"], link[rel="canonical"], link[rel="alternate"][hreflang], script[type="application/ld+json"]'
    )
    .forEach((el) => el.remove());
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
